<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid form-group" style="background-color: white">
            <h2 class="text-center p-3">รายการคืนสินค้า</h2>
            <br/>
            <div class="row form-group">
                <label class="col-sm-6 col-form-label text-capitalize text-right">
                    วันที่สร้างรายการคืนสินค้า
                </label>
                &nbsp;
                <date-picker
                    v-model="form.date"
                    type="date"
                    :not-after="currentDate"
                    :format="changeFormat"
                    :lang="lang"
                    :disabled="disable_date"
                    :show-labels="false"
                    placeholder="วันที่ใบคืนสินค้า">
                </date-picker>
            </div>
            <div class="row form-group">
                <label class="col-sm-2 col-form-label text-capitalize text-right">
                    สาเหตุการคืน
                </label>
                &nbsp;
                <label class="col-sm-3 col-form-label text-capitalize">
                    <input v-model="form.cause_id"
                           @change="getInvoiceDetails"
                           type="radio"
                           name="status"
                           value="1"
                           checked/>
                    &nbsp;สินค้าเสียหายจากโรงงาน
                </label>
                <label class="col-sm-3 col-form-label text-capitalize">
                    <input v-model="form.cause_id"
                           @change="getInvoiceDetails"
                           type="radio"
                           name="status"
                           value="2"/>
                    สินค้าเสียหายจากลูกค้า
                </label>
                <label class="col-sm-3 col-form-label text-capitalize">
                    <input v-model="form.cause_id"
                           @change="getInvoiceDetails"
                           type="radio"
                           name="status"
                           value="3"/>
                    สินค้าไม่เสียหาย
                </label>
            </div>
            <div class="row form-group">
                <div class="col-sm-4 col-xs-12 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        รหัสเซลล์
                    </label>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.sale"
                            @input="getCustomerFromSale(form.sale)"
                            :options="OptionSeller"
                            :customLabel="saleLabel"
                            placeholder="กรุณาเลือกเซลล์"
                            :show-labels="false"
                            track-by="sale_id">
                        </multiselect>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        รหัสลูกค้า
                    </label>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.customer"
                            @input="getInvoiceFromCustomer(form.customer)"
                            :options="optionCustomer"
                            :show-labels="false"
                            track-by="customer_id"
                            :customLabel="customerLabel"
                            placeholder="กรุณาเลือกลูกค้า">
                        </multiselect>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        เลขที่ใบแจ้งหนี้
                    </label>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.invoice"
                            :options="optionInvoice"
                            :show-labels="false"
                            track-by="invoice_id"
                            label="invoice_id"
                            @input="getInvoiceDetails()"
                            placeholder="กรุณาเลือกเลขที่ใบแจ้งหนี้">
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row" v-if="form.customer" style="padding-left: 30px">
                <div class="form-group" style="padding-right: 20px">
                    <label style="font-weight: bold">ชื่อลูกค้า : </label>
                    <span> {{ form.customer.name }}</span>
                </div>
                <div class="form-group" style="padding-right: 20px">
                    <label style="font-weight: bold">เบอร์โทร : </label>
                    <span> {{ form.customer.phone }}</span>
                </div>
                <div class="form-group" style="padding-right: 20px" v-if="form.invoice">
                    <label style="font-weight: bold">รถขนส่ง : </label>
                    <span> {{ form.invoice.driver.transport_type.name }}</span>
                </div>
                <div class="form-group" style="padding-right: 20px">
                    <label style="font-weight: bold">ประเภทการขนส่ง : </label>
                    <span v-if="form.customer.fixed_rate_status == 1">การขนส่งแบบต่อห่อ</span>
                    <span v-else-if="form.customer.fixed_rate_status == 2">การขนส่งแบบเหมา</span>
                    <span v-else>ไม่มีประเภทการขนส่ง</span>
                </div>
                <div class="form-group" style="padding-right: 20px" v-if="form.invoice">
                    <label style="font-weight: bold">ราคาขนส่ง : </label>
                    <span> {{ form.invoice.transport_fee | currency }} บาท</span>
                </div>
            </div>
            <br>
            <!--แสดงค่าขนส่ง--->
            <div style="width: 70%; text-align: center; margin-left: 70px" v-if="form.customer">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col"></th>
                        <template v-for="transport in optionTransportType">
                            <th scope="col" v-if="transport.id != optionTransportType.length">{{ transport.name }}</th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="transport in TransportForm">
                        <td style="text-align: right">{{ transport[0].transport_wrap_name }}</td>
                        <td v-for="item in transport" v-if="item.transport_type_id != 4">
                            <span v-if="item.price > 0">{{ item.price }}</span>
                            <span v-else>-</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!--แสดงรายการสินค้าที่ต้องการคืน-->
            <div class="col-sm-12 table-responsive">
                <span style="color: red;">*คืนสินค้าเฉพาะบิลขายที่มีการ บันทึกเรียบร้อย และ ชำระบางส่วน</span>
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th width="50px" scope="col">ลำดับ</th>
                        <th width="200px" scope="col">รหัสสินค้า</th>
                        <th width="200px" scope="col">ชื่อสินค้า</th>
                        <th width="150px" scope="col">จำนวนสั่งซื้อ</th>
                        <th width="100px" scope="col">จำนวน</th>
                        <th width="100px" scope="col">เศษ</th>
                        <th width="110px" scope="col">ราคา</th>
                        <th width="50px" scope="col">ราคาต่อหน่วยสินค้า</th>
                        <th width="100px" scope="col">จำนวน</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(detail,index) in invoice_details">
                        <td>{{ ++index }}</td>
                        <td>{{ detail.product ? detail.product.sku : '-' }}</td>
                        <td>{{ detail.product ? detail.product.name : '-' }}</td>
                        <td>{{ detail.quantity }}</td>
                        <td>
                            <input type="number" class="form-control"
                                   @input="getTransportPriceReturn"
                                   v-model="detail.quantity_return"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   v-model="detail.residues"/>
                        </td>
                        <td>{{ detail.price }}</td>
                        <td>{{ detail.unit_price = detail.product ? detail.product.unit_price : 0 }}</td>
                        <td>
                            {{ detail.total_price_return > 0 ? detail.total_price_return : 0 | currency }}
                        </td>
                    </tr>
                    </tbody>
                </table>
                <!--ค่าขนส่งที่ต้องการคืน-->
                <div class="col-sm-12 table-responsive" v-if="form.transport_price_return.length > 0">
                    <table class="table table-bordered text-center">
                        <thead>
                        <tr>
                            <th scope="col">ลำดับ</th>
                            <th scope="col">ประเภทสินค้า</th>
                            <th scope="col">จำนวน</th>
                            <th scope="col" width="200px">ราคา/หน่วย</th>
                            <th scope="col">ราคาขนส่งรวม</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(transport, index) in form.transport_price_return">
                            <tr>
                                <td>
                                    {{ ++index }}
                                </td>
                                <td>
                                    <template v-if="transport.product_type_id">
                                        {{ transport.product_type_name }}
                                        <span v-if="transport.form_size_id">({{ transport.form_size_name }})</span>
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>
                                    {{ transport.quantity }}
                                </td>
                                <td>
                                    <input type="number" class="form-control"
                                           v-model="transport.transport_unit_price"/>
                                    <div style="display: none">
                                        {{ transport.price = transport.transport_unit_price ? transport.transport_unit_price : 0 }}
                                    </div>
                                </td>
                                <td>
                                    {{
                                        transport.transport_total =
                                            parseFloat(transport.price) * parseFloat(transport.quantity) | currency
                                    }}
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <div class="col-sm-8 col-xs-12 row form-group" style="padding-left: 35px">
                <label class="col-sm-2 col-xs-12 col-form-label text-capitalize text-left">
                    หมายเหตุ
                </label>
                <div class="col-sm-8 col-xs-12">
                    <textarea
                        class="form-control"
                        rows="5"
                        v-model="form.reason"
                    ></textarea>
                </div>
            </div>
            <div class="row" style="padding-left: 35px">
                <template v-if="optionInvoiceBack.length > 0" v-for="invoice in optionInvoiceBack">
                    <div class="col-sm-8" v-if="form.cause_id != 3">
                        <input type="checkbox" :id="invoice.invoice_id"
                               :value="invoice.invoice_id"
                               v-model="form.invoice_back_id"/> &nbsp;
                        <label :for="invoice.invoice_id">{{ invoice.invoice_number }}</label>&nbsp;
                        <span v-if="form.status_id != 3" style="color: #00a699">
                                (ยอดใบบิล {{ invoice.invoice_total | currency }})
                            </span>&nbsp;
                        <input type="number"
                               min="0" :max="invoice.invoice_total"
                               class="col-sm-2"
                               v-model="invoice.cash_back"/>
                    </div>
                    <div class="col-sm-8" v-if="form.cause_id == 3 && form.invoice.id == invoice.invoice_id">
                        <input type="checkbox"
                               :value="invoice.invoice_id"
                               v-model="form.invoice_back_id"/> &nbsp;
                        <label>{{ invoice.invoice_number }}</label>&nbsp;
                        <span v-if="form.status_id != 3" style="color: #00a699">
                                (ยอดใบบิล {{ invoice.invoice_total | currency }})
                            </span>&nbsp;
                        <input type="number"
                               min="0" :max="invoice.invoice_total"
                               class="col-sm-2"
                               v-model="invoice.cash_back"/>
                    </div>
                </template>
            </div>
            <br/>
            <div class="text-right" style="padding-right: 20px">
                <br/>
                <span style="padding-left: 25px">ยอดรวมทั้งหมด : {{ invoice_total | currency }} บาท</span>
                <br/>
                <span
                    style="padding-left: 25px">ยอดที่ต้องคืนทั้งหมด : {{ calculateReturnProduct | currency }} บาท</span>
                <br/>
                <span style="padding-left: 25px;font-weight: bold">ยอดคงเหลือ :  {{ balance_invoice_total | currency }} บาท</span>
            </div>
            <br/>
            <div class="text-right"
                 v-if="form.status_id != 2">
                <button @click="saveSaleReturnProduct"
                        class="btn btn-success mb-3"
                        :disabled="onSave"
                        style="margin-right: 20px">
                    <icon name="save"></icon>
                    บันทึก
                </button>
            </div>
        </div>
        <!--<pre class="alert alert-primary">{{ form.transport_price_return }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    name: "sale-return-products-form2",
    props: {
        status: {default: null}
    },
    components: {
        Multiselect,
        DatePicker
    },
    data() {
        return {
            disable_date: false,
            items: [
                {
                    text: "รายการคืนสินค้า",
                    to: {name: "sale-return-products-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            currentDate: "",
            check_invoice_back: [],
            onSave: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        //console.log("status :",this.status);
        this.check_invoice_back = this.form.invoice_back_id;
        if (!this.form.id) {
            this.$store.dispatch("SaleReturnProduct/clearDataForm");
        } else {
            this.disable_date = true;
        }
        this.getCurrentDate();
        //ดึงค่าขนส่งมาจากลูกค้า
        this.$store.dispatch("Customer/getCustomerTransportForm");
        //ประเภทการขนส่ง
        this.$store.dispatch("TransportType/transportTypeAll");
    },

    computed: {
        ...mapState({
            form: state => {
                return state.SaleReturnProduct.form;
            },
            OptionSeller: state => {
                return state.Seller.data;
            },
            optionCustomer: state => {
                return state.SaleReturnProduct.customers;
            },
            optionInvoice: state => {
                return state.SaleReturnProduct.invoices;
            },
            invoice_details: state => {
                return state.SaleReturnProduct.form.details;
            },
            optionInvoiceBack: state => {
                return state.SaleReturnProduct.invoices_back;
            },
            //ดึงค่าขนส่งมาจากลูกค้า
            transport_form_customer: state => {
                return state.Customer.transport_form
            },
            //ประเภทการขนส่ง
            optionTransportType: state => {
                return state.TransportType.transport_type_all;
            }
        }),
        invoice_total() {
            let total = 0;
            if (this.form.invoice) {
                total = this.form.invoice.total
            } else {
                total = 0;
            }
            return parseFloat(total);

        },

        //หายอดคงเหลือ
        balance_invoice_total() {
            let balance = parseFloat(this.invoice_total) - parseFloat(this.calculateReturnProduct)
            if (balance < 0) {
                balance = 0
            }
            return balance;
        },
        //คำนวนผลรวมทั้งหมดที่ต้องการคืน รวมค่าขนส่ง
        calculateReturnProduct() {
            let sum_total = 0;
            sum_total = this.invoice_details.reduce((carry, detail) => {
                if (!detail.quantity_return) {
                    detail.quantity_return = 0;
                }
                if (!detail.price_return) {
                    detail.price_return = 0;
                }
                if (detail.quantity_return > detail.quantity) {
                    detail.quantity_return = detail.quantity;
                }
                return carry + (this.calculateReturnOneProduct(detail));
            }, 0);
            sum_total = parseFloat(sum_total) + parseFloat(this.calculateTransportPrice);
            return parseFloat(sum_total);
        },
        //คำนวนค่าขนส่งสินค้า
        calculateTransportPrice() {
            let transport_price = this.form.transport_price_return.reduce((carry, detail) => {
                //console.log(detail.transport_total);
                return carry + parseFloat(detail.transport_total)
            }, 0);
            return this.form.transport_fee = parseFloat(transport_price);
        },

        //ดึงค่าขนส่งมาจากลูกค้า
        TransportForm() {
            if (this.form.transport_form_customer.length > 0) {
                return this.form.transport_form_customer
            } else {
                return this.transport_form_customer
            }
        },
        validateInvoiceBack() {
            let pay = 0;
            this.optionInvoiceBack.reduce((carry, invoice) => {
                if (this.form.invoice_back_id.includes(invoice.invoice_id)) {
                    if (!invoice.cash_back) {
                        invoice.cash_back = 0;
                    }
                    pay += parseFloat(invoice.cash_back)
                }
            }, 0);
            return pay;
        },
    },
    methods: {
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
            this.form.date = this.currentDate;
        },
        saleLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        customerLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        getCustomerFromSale(sale) {
            if (sale) {
                let sale_id = sale.id;
                //console.log(sale.id);
                this.$store.dispatch("SaleReturnProduct/getCustomerFromSale", sale_id);
            } else {
                this.$store.dispatch("SaleReturnProduct/clearCustomer")
            }
        },

        getInvoiceFromCustomer(customer) {
            if (customer) {
                let customer_id = customer.id;
                this.$store.dispatch("SaleReturnProduct/getInvoiceFromCustomer", customer_id).then(() => {
                    //ดึงค่าขนส่งมาจากลูกค้า
                    this.$store.dispatch("SaleReturnProduct/getTransportFromCustomer", customer_id).then(res => {
                        this.form.transport_form_customer = res;
                    })
                }).then(() => {
                    this.getInvoiceBack();
                })
            }
        },

        getInvoiceDetails() {
            if (this.form.invoice) {
                let invoice_id = this.form.invoice.id;
                let cause_id = this.form.cause_id;
                //console.log("invoice_id",invoice_id);
                //console.log("cause_id",cause_id);
                this.$store.dispatch("SaleReturnProduct/getInvoiceDetails", {invoice_id, cause_id});
            }
        },

        getInvoiceBack() {
            if (this.form.customer) {
                this.$store.dispatch("SaleReturnProduct/getInvoiceBack", this.form.customer.id);
            }
        },

        goToSaleReturnProductList() {
            this.$store.dispatch("SaleReturnProduct/clearDataForm");
            this.$router.push({
                name: "sale-return-products-list"
            });
        },

        saveSaleReturnProduct() {
            if (!this.form.date) {
                alert("กรุณาเลือกวันที่");
            } else if (!this.form.cause_id) {
                alert("กรุณาเลือกสาเหตุการคืน");
            } else if (!this.form.sale) {
                alert("กรุณาเลือกรหัสเซลล์");
            } else if (!this.form.customer) {
                alert("กรุณาเลือกรหสัลูกค้า");
            } else if (!this.form.invoice) {
                alert("กรุณาเลือกเลขที่ใบแจ้งหนี้");
            } else if (this.form.transport_fee > this.form.invoice.transport_fee) {
                alert("ค่าขนส่งเกินจำนวนที่ต้องคืน");
            } else if (!(this.form.invoice_back_id.length > 0)) {
                alert("กรุณาเลือกบิลขายที่ต้องการคืน");
            } else if (this.form.invoice_back_id.length > 0 &&
                this.validateInvoiceBack !== (this.calculateReturnProduct)) {
                alert("ยอดคืนไม่ถูกต้องกรุณาระบุใหม่อีกครั้ง");
            } else {
                if (this.form.sale) {
                    this.form.sale_id = this.form.sale.id;
                }
                if (this.form.customer) {
                    this.form.customer_id = this.form.customer.id;
                }
                if (this.form.invoice) {
                    this.form.invoice_id = this.form.invoice.id;
                }
                if (this.status) {
                    this.form.status_id = this.status;
                }
                let invoices = [];
                this.optionInvoiceBack.forEach(invoice => {
                    if (this.form.invoice_back_id.includes(invoice.invoice_id)) {
                        invoices.push(invoice);
                    }
                });
                let data = {
                    date: this.form.date,
                    status_id: this.form.status_id,
                    cause_id: this.form.cause_id,
                    reason: this.form.reason,
                    sale_id: this.form.sale_id,
                    customer_id: this.form.customer_id,
                    invoice_id: this.form.invoice_id,
                    invoice_back_id: this.form.invoice_back_id.toString(),
                    invoice_back: invoices,
                    cn_number: this.form.cn_number,
                    transport_fee: this.form.transport_fee,
                    //invoice total , invoice balance
                    invoice_balance: this.balance_invoice_total,
                    invoice_total: this.invoice_total,
                    return_price: this.calculateReturnProduct,
                    details: this.invoice_details,
                    transport_price_return: this.form.transport_price_return
                };
                // //console.log(data);
                this.onSave = true;
                this.$store.dispatch("SaleReturnProduct/saveSaleReturnProduct", {
                    id: this.form.id,
                    data: data
                }).then(() => {
                    this.$store.dispatch("SaleReturnProduct/setSaleReturnProduct").then(() => {
                        this.goToSaleReturnProductList();
                    });
                }).catch(err => {
                    this.onSave = false;
                });
            }
        },
        //มีแต่โปรโมชั่น
        calculateReturnOneProduct(detail) {
            if (detail) {
                let quantity = 0;
                let residues = 0;
                let price = detail.price;
                let unit_price = detail.product ? detail.product.unit_price : 0;
                if (detail.quantity_return > detail.quantity) {
                    detail.quantity_return = detail.quantity;
                }
                if (detail.quantity_return > 0) {
                    quantity = detail.quantity_return;
                }
                if (detail.residues > 0) {
                    residues = detail.residues;
                }
                detail.total_price_return = (parseFloat(quantity) * parseFloat(price)) + (parseFloat(residues) * parseFloat(unit_price));
                return detail.total_price_return;
            }
            // if(detail.promotion){
            //     if (detail.promotion.discount_status_id == 2) {
            //         return !detail.quantity_return || detail.quantity_return < 0
            //             ? detail.quantity_return = 0
            //             : !detail.price_return ? detail.price_return = 0
            //                 : parseFloat(detail.quantity_return) * (parseFloat(detail.price_return) -
            //                 (parseFloat(detail.price_return) * (parseFloat(detail.promotion.discount)) / 100))
            //     } else {
            //         return !detail.quantity_return || detail.quantity_return < 0
            //             ? detail.quantity_return = 0
            //             : !detail.price_return ? detail.price_return = 0
            //                 : parseFloat(detail.quantity_return) * parseFloat(detail.price_return)
            //                 - (parseFloat(detail.quantity_return) * (parseFloat(detail.promotion.discount)))
            //     }
            // }
            // else{
            //     return !detail.quantity_return || detail.quantity_return < 0
            //         ? detail.quantity_return = 0
            //         : !detail.price_return ? detail.price_return = 0
            //             : parseFloat(detail.quantity_return) * parseFloat(detail.price_return)
            // }
        },

        //ดึงราคาขนส่งแต่ละชิ้นมาจากหลังบ้าน
        getTransportPriceReturn() {
            if (this.form.customer && this.form.invoice) {
                let data = {
                    customer_id: this.form.customer.id,
                    fixed_rate_status: this.form.customer.fixed_rate_status,
                    transport_type_id: this.form.invoice.transport_type_id,
                    status_transport_other: this.form.invoice.status_transport_other,
                    details: this.form.details,
                    flag: 2 //มาจาก คืนสินค้า เพื่อการคำนวณ
                };
                //console.log(data);
                this.$store.dispatch("Invoice/getInvoiceTransportPrice", data).then(res => {
                    this.form.transport_price_return = res;
                });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
thead {
    background-color: gray;
}

tbody {
    background-color: white;
}

textarea {
    resize: none;
}
</style>
